import Application from '../Application';
import BaseView, { DomainModel3D } from './BaseView';
import logging from '../logging';
import pc from '../ParametricCache';
import { Mesh, BufferGeometry, Material } from 'three';
import { ParametricPart } from '../domain';

const log = logging('view');

export default class ParametricPartView extends BaseView {

    declare model: ParametricPart;

    mesh: Mesh;

    constructor(model: DomainModel3D, app: Application) {
        super(model, app);
        this.init();
    }

    make() {
        this.name = this.model.name;

        this.mesh = new Mesh(new BufferGeometry(), new Material());
        this.mesh.castShadow = this.mesh.receiveShadow = true;
        this.add(this.mesh);

        this.mesh.userData.isSelectable = true;
        this.mesh.userData.isMovable = true;
        this.mesh.userData.cursor = 'row-resize';
        this.mesh.userData.isParametricPart = true;

        this.highlights.add(this.mesh);
    }

    bind() {
        this.bindMaterialArray(this.mesh, this.model.materials);
        let changeSize = this.changeSize.bind(this);
        this.model.bind('width', changeSize);
        this.model.on('height', changeSize);
        this.model.on('depth', changeSize);
    }

    private async changeSize() {
        if(this.model.name == 'HangBar') {
            this.mesh.position.z = 12;
            this.updates.queue(
                async () => await pc.make(
                    this.model.name,
                    this.app.defaults.style.rod,
                    this.model.width),
                (geo) => {
                    this.mesh.geometry = geo;
                }
            );
        }
        else if(this.model.name == 'SlantedShelfWithFence') {
            this.updates.queue(
                async () => await pc.make(
                    this.model.name,
                    this.app.defaults.style.fence,
                    this.model.width,
                    this.model.height,
                    this.model.depth),
                (geo) => {
                    this.mesh.geometry = geo;
                }
            );
        }
        else {
            this.updates.queue(
                async () => await pc.make(this.model.name,
                    this.model.width, this.model.height, this.model.depth),
                (geo) => {
                    this.mesh.geometry = geo;
                }
            );
        }
    }

}
